import { render, staticRenderFns } from "./AllBusinessNameRegistrationSubmissions.vue?vue&type=template&id=e26f3d66&scoped=true&"
import script from "./AllBusinessNameRegistrationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBusinessNameRegistrationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBusinessNameRegistrationSubmissions.vue?vue&type=style&index=0&id=e26f3d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26f3d66",
  null
  
)

export default component.exports